import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import {
  PushNotifications,
  PermissionStatus,
} from '@capacitor/push-notifications';

/**
 * `@capacitor/push-notifications` has no web implementation — every call rejects
 * with `"PushNotifications" plugin is not implemented on web`. Route all push usage
 * through this wrapper so the web build (ionic serve / v4sim emulator) is a silent
 * no-op instead of throwing uncaught promise rejections. On native it delegates
 * straight to the plugin.
 */
export const Push = {
  requestPermissions(): Promise<PermissionStatus> {
    if (!Capacitor.isNativePlatform()) {
      return Promise.resolve({ receive: 'denied' } as PermissionStatus);
    }
    return PushNotifications.requestPermissions();
  },

  register(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return Promise.resolve();
    }
    return PushNotifications.register();
  },

  addListener(
    eventName: 'registration',
    listener: (...args: any[]) => void
  ): Promise<PluginListenerHandle> {
    if (!Capacitor.isNativePlatform()) {
      return Promise.resolve({ remove: () => Promise.resolve() });
    }
    return PushNotifications.addListener(eventName, listener as any);
  },

  removeAllDeliveredNotifications(): Promise<void> {
    if (!Capacitor.isNativePlatform()) {
      return Promise.resolve();
    }
    return PushNotifications.removeAllDeliveredNotifications();
  },
};
